export const WindowTypes = {
  STOCK: 'stock',
  INSURANCE: 'insurance'
};
